import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CardPreviewConfigInterface } from '../../data-access/models/card-preview-config.interface';
import { TempNgxButtonComponent } from '@client-monorepo/common/ui-components';
import { PreviewComponent } from '../preview/preview.component';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';

@Component({
  selector: 'daily-bank-card-saved-success-message',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, PreviewComponent, TempNgxButtonComponent],
  templateUrl: './saved-success-message.component.html',
  styleUrl: './saved-success-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SavedSuccessMessageComponent {
  card = computed<CardPreviewConfigInterface>(() => {
    return {
      ...this.bottomSheetService.data(),
      isPinned: false,
      isExpanded: false,
    };
  });

  bottomSheetService = inject(NgxBottomSheetService);

  submitToShaparak() {}
}
